var _rect, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotyet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4_174",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4_174)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.87609 18.957L4.87616 18.9569C8.63046 14.4202 14.2362 10.1572 20.0001 10.1572C25.7627 10.1572 31.3671 14.4171 35.1239 18.9568C35.6265 19.5645 35.6241 20.4438 35.124 21.0486C34.1869 22.181 32.2225 24.366 29.6049 26.2714L29.6049 26.2714C26.3039 28.6744 23.1325 29.844 19.9947 29.8427C16.8569 29.8415 13.689 28.6692 10.3952 26.2714L10.3952 26.2714C7.77764 24.366 5.81322 22.181 4.87616 21.0486L4.87609 21.0485C4.37464 20.4428 4.37464 19.5627 4.87609 18.957ZM27.3971 20.0027C27.3971 15.9234 24.0794 12.6057 20.0001 12.6057C15.9207 12.6057 12.603 15.9234 12.603 20.0027C12.603 24.0821 15.9207 27.3998 20.0001 27.3998C24.0794 27.3998 27.3971 24.0821 27.3971 20.0027Z",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotyet);
export default __webpack_public_path__ + "static/media/Notyet.04cac2fd0f50f0cf0734990d06306851.svg";
export { ForwardRef as ReactComponent };